import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

export interface DataHealthKpiCardProps {
  /**
   * Palette references only, never hex - the alert variant is
   * `error.transparent` / `error.light` / `error.text`. Left unset the card
   * is neutral, which is what every card that is only reporting a number
   * should be.
   */
  fill?: { bg: string; border: string; text?: string }
  label: string
  /** Makes the whole card a link-like target. */
  onClick?: () => void
  sub: ReactNode
  value: ReactNode
}

/**
 * One tile in a Datahälsa KPI row. Shared by all three tabs so the rows read
 * as the same row with different numbers in it.
 */
const DataHealthKpiCard = (props: DataHealthKpiCardProps) => {
  const { fill, label, onClick, sub, value } = props

  return (
    <Box
      onClick={onClick}
      sx={{
        bgcolor: fill?.bg ?? 'background.paper',
        border: '1px solid',
        borderColor: fill?.border ?? 'divider',
        borderRadius: '16px',
        minWidth: 0,
        overflow: 'hidden',
        p: '18px 20px',
        ...(onClick
          ? {
              cursor: 'pointer',
              '&:hover': { borderColor: 'text.disabled' }
            }
          : null)
      }}
    >
      <Text
        sx={{
          color: 'text.secondary',
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {label}
      </Text>
      <Text
        component="div"
        sx={{
          color: fill?.text ?? 'text.primary',
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '-0.05em',
          lineHeight: 1.1,
          mt: 0.5,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
        variant="h3"
      >
        {value}
      </Text>
      <Text
        sx={{
          color: fill?.text ?? 'text.secondary',
          fontSize: 13,
          mt: 0.5,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {sub}
      </Text>
    </Box>
  )
}

DataHealthKpiCard.displayName = 'DataHealthKpiCard'
export default DataHealthKpiCard
